'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/**
 * ProcessJs.
 * Creation of Dynamic Dedicated WebWorkers, definition of dependencies, promise support.
 * @module process.js
 * @author @SurenAt93
 */


var _defaultOptions = require('./defaultOptions.js');

var _createWorkerSource = require('./utils/createWorkerSource.js');

var _createWorkerSource2 = _interopRequireDefault(_createWorkerSource);

var _generators = require('./utils/generators.js');

var _thread = require('./thread.js');

var _thread2 = _interopRequireDefault(_thread);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * The Process class
 */


var Process = function () {
  /**
   * Create a default options and hash of threads.
   * @param {Object} options - The options for instance of Process
   */
  function Process(options) {
    _classCallCheck(this, Process);

    var defaultOptions = (0, _defaultOptions.getDefaultOptions)();
    var currentOptions = options ? _extends({}, options, defaultOptions) : defaultOptions;
    var id = currentOptions.id,
        name = currentOptions.name;
    this.id = id;
    this.name = name;
    this.__threads = {};
  }
  /**
   * Static method for getting hardware concurrency
   * @returns {number} - The hardware concurrency
   */


  _createClass(Process, [{
    key: 'setSource',

    /**
     * Public method for setting source for process
     * @param {Function|String} source - The function, which should run in new process
     * or it also can be a string with particular function inside
     * @param {Array} deps - Optional ::: Dependencies for new env
     * @returns {Thread} - The Promisified worker
     */
    value: function setSource(source) {
      var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var fnName = arguments[2];
      var isFunction = false;

      if (!source) {
        throw new Error('Failed to construct ::: First argument required');
      } else if (typeof source === 'function') {
        isFunction = true;
      } else if (typeof source === 'string') {
        if (!fnName) {
          throw new Error('Failed to construct ::: If you are trying to execute the source as a string\n          you also need to provide a function name as a third argument.');
        }
      } else {
        throw new Error('The type of "source" should be either function or string');
      }

      var transformedSource = (0, _createWorkerSource2.default)(isFunction, source, deps, fnName);
      var blob = new Blob([transformedSource], {
        type: 'application/javascript'
      });
      var worker = new Worker(URL.createObjectURL(blob));
      var currentThreadId = (0, _generators.generateRandomId)();
      this.__threads[currentThreadId] = new _thread2.default(worker);
      return this.__threads[currentThreadId];
    }
    /**
     * Public method for killing process
     * @returns {undefined}
     */

  }, {
    key: 'kill',
    value: function kill() {
      var _this = this;

      Object.keys(this.__threads).forEach(function (threadId) {
        _this.__threads[threadId].kill();
      });
      this.__threads = {};
    }
  }], [{
    key: 'getHardwareConcurrency',
    value: function getHardwareConcurrency() {
      return navigator.hardwareConcurrency;
    }
  }]);

  return Process;
}();

exports.default = Process;